import moment from 'moment';

export const activePeriod = () => {
  const freezePrevMonth = moment().date() > 5;
  const currentMonth = moment().month();
  const prevMonth = moment().subtract(1, 'months').endOf('month').month();

  return [freezePrevMonth, currentMonth, prevMonth];
};

export const disabledDate = (
  current,
  freezePrevMonth,
  currentMonth,
  prevMonth
) => {
  return freezePrevMonth
    ? !(current.month() === currentMonth)
    : !(current.month() === currentMonth || current.month() === prevMonth);
};

export const activeMonth = (current, month) => {
  return current.month() === month;
};

export const isSunday = (current) => {
  return current.weekday() === 0;
};

export const calculateNumberOfBusinessDays = (start, end) => {
  const Sunday = 0;
  let current = start.clone();
  let days = 0;

  while (current <= end) {
    if (current.day() !== Sunday) {
      days++;
    }
    current.add(1, 'days');
  }
  return days;
};
